import { useRequest } from '@10000/react'
import { Body, Box, Button, CenteredBox, H3 } from '../widgets'
import { InputScreen, useBackground, useShell } from '../layout'
import { assetUrl } from '../../utilities.js'

export const Confirmation = ({ active }) => {
  const request = useRequest('squiz')

  useShell({ active, mode: 'logo' })
  useBackground().set({ active, background: 'var(--blue)' })

  const startAnalytics = () => request('recapStarted')

  return (
    <InputScreen gap={24} height="100dvh" justifyContent="space-between">
      <Box position="absolute" inset background={`var(--black-fade), url(${assetUrl('gifs/confetti.gif')}) center / 900px 1200px`} />

      <CenteredBox r="50%" overflow="hidden" zIndex={1}>
        <video src={assetUrl('videos/morphing-shapes.mp4')} autoPlay muted playsInline loop style={{ width: 120 }} />
        <img src={assetUrl('party.png')} alt="party" style={{ position: 'absolute' }} />
      </CenteredBox>

      <Box column gap={24} zIndex={1}>
        <H3>You&apos;re in!</H3>

        <Body lineHeight="24px" align="center">
          Thank you for registering for Shivoo.
          We will keep you posted and make sure you’re the first to know when we go live.
          In the meantime enjoy your personalized results!
        </Body>
      </Box>

      <Button fullWidth onClick={startAnalytics} style={{ zIndex: 1 }}>
        Take me to results
      </Button>
    </InputScreen>
  )
}